<template>
	<tr
		:class="[
			'TableRow',
			getStatusClass(lead.status),
			isExpanded && 'expanded',
		]"
	>
		<td>{{ lead.fullname }}</td>
		<td class="TableRow_dateCell">{{ formatDate(lead.date) }}</td>
		<td class="TableRow_statusCell">
			<select
				class="TableRow_statusSelect status-color"
				v-model="lead.status"
				@change.stop="() => handleChange()"
			>
				<option
					v-for="(option, key) in statusOptions"
					:value="option"
					:disabled="disableOption(option)"
					:key="key"
				>
					{{ option }}
				</option>
			</select>
		</td>
		<td class="TableRow_controls">
			<v-btn
				:disabled="ctaDisabled"
				:color="ctaColor"
				type="button"
				@click="saveLead"
				small
				>{{ ctaLabel }}</v-btn
			>
			<button class="link" type="button" @click="handleExpand">
				<span v-if="!isExpanded"> +View Detail </span>
				<span v-else> -Close Detail </span>
			</button>
		</td>
	</tr>
</template>

<script>
import dayjs from "dayjs";
import { LEAD_STATUSES, BUS_EVENTS } from "@/constants";
import { EventBus } from "@/utilities";
import { mapActions } from "vuex";

export default {
	name: "TableRow",
	props: {
		item: Object,
		expand: Function,
		isExpanded: Boolean,
	},
	data() {
		return {
			lead: {
				status: LEAD_STATUSES.NEW,
			},
			leadPrevStatus: LEAD_STATUSES.NEW,
			statusOptions: LEAD_STATUSES,
			revFocused: false,
			ctaLabel: "Saved",
			ctaColor: "primary",
			ctaDisabled: true,
		};
	},
	beforeMount() {
		this.lead = JSON.parse(JSON.stringify(this.item)); //object deep copy
		this.leadPrevStatus = this.lead.status;

		EventBus.$on(BUS_EVENTS.LEAD_DOWN_SAVED, this.updateCTA);
		EventBus.$on(BUS_EVENTS.LEAD_DOWN_CANCELED, this.resetStatus);

		EventBus.$on(BUS_EVENTS.LEAD_LOST_SAVED, this.updateCTA);
		EventBus.$on(BUS_EVENTS.LEAD_LOST_CANCELED, this.resetStatus);
	},
	methods: {
		...mapActions(["saveExtraVisitors"]),
		disableOption(option) {
			// return option === LEAD_STATUSES.NEW;
			return false;
		},
		formatDate(date = "") {
			return dayjs(date).format("MM/DD/YY");
		},

		getStatusClass(status) {
			const statusKey = Object.keys(LEAD_STATUSES).find(
				(key) => LEAD_STATUSES[key] === status
			);
			return `status-${statusKey ? statusKey.toLowerCase() : ''}`;
		},

		handleChange() {
			this.revFocused = true;
			if (this.lead.status === LEAD_STATUSES.DOWN) {
				EventBus.$emit(BUS_EVENTS.LEAD_DOWN, this.lead);
			}
		},

		updateCTA(leadChanged = false) {
			this.ctaDisabled = !leadChanged;
			this.ctaLabel = leadChanged ? "Update" : "Saved";
			this.ctaColor = leadChanged ? "success" : "primary";
		},

		resetStatus() {
			this.lead.status = this.leadPrevStatus;
		},

		async handleExpand() {
			this.expand(!this.isExpanded);
			if (!this.isExpanded) {
				EventBus.$emit(BUS_EVENTS.LEAD_UNEXPANDED);
			}
		},
		async saveLead() {
			/* if (this.lead.status == "New") {
				EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
					type: "warning",
					message: "Please change lead status",
					duration: 2e3,
				});
				return false;
			} */
			const extrafields = new FormData();
			extrafields.append("visualvisitor_id", this.lead.id);
			if (this.lead.visualvisitor_extra_id !== undefined)
				extrafields.append("id", this.lead.visualvisitor_extra_id);
			extrafields.append("status", this.lead.status);
			extrafields.append("save_history", true);

			try {
				const visualvisitor_extra_id = await this.saveExtraVisitors(
					extrafields
				);
				if (this.lead.visualvisitor_extra_id === undefined)
					this.lead.visualvisitor_extra_id = visualvisitor_extra_id;

				EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
					type: "success",
					message: "Lead Saved Successfully",
					duration: 2e3,
				});
				EventBus.$emit(BUS_EVENTS.STATS_O_UPDATED);

				this.updateCTA(false);
				this.revFocused = false;
			} catch (error) {
				EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
					type: "error",
					message: "Lead cannot be saved. Please try again later.",
					duration: 2e3,
				});
				console.error(err.response.status);
			}
		},
	},
	watch: {
		lead: {
			handler(value, oldValue) {
				const leadChanged =
					JSON.stringify(value) !== JSON.stringify(this.item);
				this.updateCTA(leadChanged);

				this.leadPrevStatus = this.item.status;
			},
			deep: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";
.TableRow {
	position: relative;
	&:hover {
		background: none !important;
	}
	&.expanded {
		background: #efefef !important;
		td {
			border-bottom-color: #efefef !important;
			padding-bottom: 0 !important;
		}
	}
	&_dateCell {
		// width: 130px;
	}
	&_statusCell {
		// width: 160px;
	}
	&_statusSelect {
		font-size: 13px;
		background: #ffffff no-repeat right 10px center;
		display: block;
		width: 110px;
		max-width: 100%;
		height: 22px;
		padding: 0 10px;
		border: 1px solid;
		border-radius: 6px;
	}
	&_formCell {
		width: 320px;
		&-entry {
			margin-bottom: 8px;
		}
		label {
			font-size: 13px;
			min-width: 120px;
		}
		strong {
			color: $purple;
		}

		/deep/ .revenueInput {
			position: relative;
			input,
			.mask {
				font-size: 13px;
				background: #ffffff;
				display: block;
				width: 90px;
				max-width: 100%;
				height: 22px;
				padding: 0 10px;
				border: 1px solid #c3c3c3;
				border-radius: 6px;
				appearance: none;
			}
			input {
				-moz-appearance: textfield;
				appearance: none;
				&::-webkit-outer-spin-button,
				&::-webkit-inner-spin-button {
					-webkit-appearance: none;
					margin: 0;
				}
			}
			.mask {
				position: absolute;
				top: 0;
				z-index: 1;
				pointer-events: none;
			}
			.symbol {
				color: $purple;
				height: 1em;
				margin-top: -0.5em;
				line-height: 1;
				position: absolute;
				top: 50%;
				right: 0.5em;
				z-index: 1;
				pointer-events: none;
			}
		}

		&.focus {
			/deep/ .revenueInput {
				.mask {
					border-color: #fc7e22;
				}
			}
		}

		.formTotal {
			&-label {
				flex: 1 1;
			}
			&-value {
				width: 90px;
			}
		}
	}
	&_controls {
		width: 150px;
		text-align: center;
		position: relative;
		&::before {
			background: #e2e2e2;
			display: block;
			width: 1px;
			height: calc(100% - 40px);
			position: absolute;
			top: 20px;
			left: 0;
			z-index: 1;
			content: "";
		}
	}
	.link {
		font-size: 12px;
		color: $purple;
		display: inline-block;
		margin: 0;
		font-weight: 500;
	}

	&.status {
		&-new {
			.status-color {
				color: $red;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-red.svg");
			}
		}
		&-tentative {
			.status-color {
				color: $yellow;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-yellow.svg");
			}
		}
		&-definite {
			.status-color {
				color: $green;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-green.svg");
			}
		}
		&-prospect {
			.status-color {
				color: $blue;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-blue.svg");
			}
		}
		&-lost {
			.status-color {
				color: darken($red, 20%);
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-red.svg");
			}
		}
		&-down {
			opacity: 0.4;
			cursor: not-allowed;
			// pointer-events: none;
			.status-color {
				color: #a0a0a0;
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-darkgray.svg");
			}
			> * {
				cursor: inherit;
			}
		}
		&-contacted {
			.status-color {
				color: darken($mint, 20%);
			}
			.TableRow_statusSelect {
				background-image: url("~@/assets/img/arrow-select1-mint.svg");
			}
		}
	}
	/* .v-btn {
        min-width: 90px !important;
        &.v-btn--disabled{
            background: lighten( desaturate($purple, 50%), 20% ) !important;
            color: #FFF !important;
        }
    } */
}
</style>



// WEBPACK FOOTER //
// src/components/TableOutbound/TableRow.vue